import {
  getAccountAccess,
  inviteAccountAccess,
  updateAccountAccess,
  revokeAccountAccess,
} from "@/services/PeopleService";

export const fetchAccountPeople = async ({ commit }, accountKey) => {
  commit("setLoading", true);

  try {
    const people = await getAccountAccess(accountKey);
    commit("setPeople", people);
    return people;
  } finally {
    commit("setLoading", false);
  }
};

export const invitePerson = async (context, { accountKey, email, assignments }) => {
  await inviteAccountAccess(accountKey, email, assignments);
  return context.dispatch("fetchAccountPeople", accountKey);
};

export const updatePerson = async (context, { accountKey, person, assignments }) => {
  await updateAccountAccess(accountKey, person, assignments);
  return context.dispatch("fetchAccountPeople", accountKey);
};

export const revokePerson = async (context, { accountKey, person }) => {
  await revokeAccountAccess(accountKey, person);
  return context.dispatch("fetchAccountPeople", accountKey);
};
